import Button from '@jetbrains/ring-ui/components/button/button'
import Dropdown from '@jetbrains/ring-ui/components/dropdown/dropdown'
import {Directions} from '@jetbrains/ring-ui/components/popup/popup.consts'
import {memo} from 'react'

import Popup from '../../../../../common/Popup/Popup.lazy'
import SvgIcon from '../../../../../common/SvgIcon/SvgIcon'
import styles from '../BuildLogNavigation.css'

const popupDirections = [Directions.LEFT_TOP]

type Props = {
  disabled: boolean
  icon?: string | null
  label: string
  hint: string
  className: string
  onClick: () => unknown
}

function BuildLogNavigationButton({icon, label, hint, onClick, disabled, className}: Props) {
  const button = (
    <Button
      aria-label={label}
      className={className}
      onClick={onClick}
      disabled={disabled}
      data-test={!disabled ? 'build-log-navigation-button' : undefined}
    >
      {icon != null ? <SvgIcon icon={icon} /> : label}
    </Button>
  )

  if (disabled) {
    return button
  }

  return (
    <Dropdown anchor={button} hoverMode clickMode={false}>
      <Popup
        directions={popupDirections}
        className={styles.tooltip}
        left={-2}
        top={-2}
        trapFocus={false}
      >
        {hint}
      </Popup>
    </Dropdown>
  )
}

export default memo(BuildLogNavigationButton)
